"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountCreditBalance = exports.AccountCreditCreate = exports.AccountCreditTransport = exports.AccountCreditQuery = exports.AccountCreditType = exports.AccountCreditTypeLabels = exports.AccountCreditTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.AccountCreditTypes = ['MANUAL', 'PAYMENT_APPLIED', 'PAYMENT_REVERSAL'];
exports.AccountCreditTypeLabels = {
    MANUAL: 'Manual',
    PAYMENT_APPLIED: 'Applied to Payment',
    PAYMENT_REVERSAL: 'Reversed from Payment',
};
exports.AccountCreditType = typebox_1.Type.Union(exports.AccountCreditTypes.map((value) => typebox_1.Type.Literal(value)));
exports.AccountCreditQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1, maximum: 100 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoiceID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoicePaymentID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoiceRefundID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    dateAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    dateBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    accountCreditType: typebox_1.Type.Optional(exports.AccountCreditType),
});
exports.AccountCreditTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    date: typebox_1.Type.String(),
    amount: typebox_1.Type.Number(),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    note: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoicePaymentID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceRefundID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    accountCreditType: exports.AccountCreditType,
    metadata: common_1.MetaData,
});
exports.AccountCreditCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.AccountCreditTransport, ['id', 'date', 'syncedWithAccounting', 'metadata']),
    typebox_1.Type.Object({
        date: typebox_1.Type.Optional(typebox_1.Type.String()),
    }),
]);
exports.AccountCreditBalance = typebox_1.Type.Object({
    currentCredit: typebox_1.Type.Number(),
    lastUpdatedDate: typebox_1.Type.String({ format: 'date-time' }),
});
//# sourceMappingURL=account-credit-transport.js.map